"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoriteComment = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var FavoriteComment = function FavoriteComment() {
  return react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3C21.1046 3 22 3.89543 22 5V17C22 18.1046 21.1046 19 20 19H14.91C14.6477 19.0011 14.3963 19.1053 14.21 19.29L12.72 20.78C12.5795 20.9207 12.3888 20.9998 12.19 21H11.81C11.6112 20.9998 11.4205 20.9207 11.28 20.78L9.79 19.29C9.60374 19.1053 9.35234 19.0011 9.09 19H4C2.89543 19 2 18.1046 2 17V5C2 3.89543 2.89543 3 4 3H20ZM12.5 15.81L13.5 14.81C13.5934 14.7166 13.6956 14.6158 13.8044 14.5083C15.0004 13.3278 17 11.3541 17 9.75C17 9.02065 16.7103 8.32118 16.1945 7.80546C15.6788 7.28973 14.9793 7 14.25 7C13.3966 7.0199 12.5866 7.37992 12 8C11.4147 7.37805 10.6039 7.01767 9.75 7C8.23122 7 7 8.23122 7 9.75C7 11.2838 8.82829 13.1556 9.9937 14.3488C10.158 14.517 10.3091 14.6716 10.44 14.81L11.44 15.81C11.7328 16.1025 12.2072 16.1025 12.5 15.81Z",
    fill: 'currentColor'
  });
};

exports.FavoriteComment = FavoriteComment;